import { render, staticRenderFns } from "./AddCrewBehaviour.vue?vue&type=template&id=19aa2dea&scoped=true&"
import script from "./AddCrewBehaviour.vue?vue&type=script&lang=js&"
export * from "./AddCrewBehaviour.vue?vue&type=script&lang=js&"
import style0 from "./AddCrewBehaviour.vue?vue&type=style&index=0&id=19aa2dea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aa2dea",
  null
  
)

export default component.exports